{
  "welcome": "Dalal ak jàmm ci Djayma",
  "greeting": "Nanga def!",
  "tagline": "Lu ngay soxla, danu koy indil",
  "search": "Seet ab produwe...",
  "voice_search": "Seet ak baat",
  "cart": "Paañe",
  "my_account": "Sama kont",
  "login": "Dugg",
  "register": "Bindu",
  "logout": "Génn",
  "buy_now": "Jënd",
  "add_to_cart": "Yokk ci paañe bi",
  "added_to_cart": "Yokk na ci paañe bi",
  "view_cart": "Xool paañe bi",
  "articles": "produwe",
  "items": "produwe",
  "fcfa": "FCFA",
  "loading": "Yàgg naa tuuti...",
  "error": "Am na njuumte",
  "retry": "Jéemaat",
  "back_home": "Dellu ci dallu bi",
  "not_found": "Xàtt bi amul",
  "not_found_desc": "Xàtt bii amul walla dañu ko wàcc.",
  "privacy_policy": "Politig suturlu",
  "terms": "Cëru yi",
  "contact": "Jokkoo",
  "phone": "Telefon",
  "email": "Email",
  "address": "Adres",
  "language": "Làkk",
  "all_brands": "Marka yépp",
  "all_products": "Produwe yépp",
  "footer_desc": "Sa marse bu digital — Produwe yu baax yu ñu la indil ca Dakar.",
  "newsletter": "Xibaar",
  "newsletter_placeholder": "Sa email",
  "subscribe": "Bindu",
  "rights": "Sañ-sañ yépp dañu ko moom",
  "your_cart": "Sa Paañe",
  "cart_empty": "Sa paañe bi amul dara",
  "cart_empty_desc": "Xoolal sunu katalog te yokk produwe ngir door sa komand.",
  "see_catalog": "Xool katalog bi",
  "articles_count": "{{count}} produwe",
  "articles_count_plural": "{{count}} produwe",
  "subtotal": "Tollu HT",
  "tva": "TVA (18%)",
  "total_ttc": "Tollu TTC",
  "delivery_label": "Indil",
  "delivery_next_step": "Dina ko jàpp ci etap bi ci topp",
  "min_order_warning": "Komand bu gën a ndaw : {{amount}}. Dangay soxla {{remaining}}.",
  "min_units": "Bu gën a ndaw : {{count}} bokk",
  "close": "Tëj",
  "continue_shopping": "Kontine jënd",
  "decrease_qty": "Waññi",
  "discover": "Gis",
  "increase_qty": "Yokk",
  "menu": "Menu",
  "quantity_label": "Limu: {{count}}",
  "proceed_to_order": "Def komand bi",
  "total_weight": "Diis lépp : {{weight}} kg",
  "remove_item": "Jéeral",
  "summary": "Tënk",
  "call_us": "Wàccal ñu",
  "articles_count_one": "{{count}} produwe",
  "articles_count_other": "{{count}} produwe",
  "error": {
    "generic_title": "Am na njuumte",
    "refresh_page": "Renowal xàtt bi"
  },
  "errors": {
    "rateLimited": "Jafe-jafe bu bari. Xaaral {{seconds}} segond.",
    "serverError": "Am na njuumte. Jéemaatal.",
    "unauthorized": "Sesion bi jeex na. Duggal sa bopp.",
    "networkError": "Jafe-jafe ak koneksiyon bi. Seetal sa internet."
  },
  "accessibility": {
    "skip_to_content": "Dem ci dëkk bi"
  },
  "contact_page": {
    "seo_title": "Contact",
    "seo_description": "Jokkoo ak CIEDA — Compagnie Import Export & Distribution Africaine. Dakar, Senegaal.",
    "title": "Jokkoo ak nu",
    "subtitle": "Am nga laaj, komand yu xeeju, walla komand grossiste? Sa ekip bi dinañu la tontu gaawal.",
    "call": {
      "title": "Woteel nu",
      "description": "Wax ak sa ekip commercial ci wolof walla français."
    },
    "whatsapp": {
      "title": "WhatsApp",
      "description": "Yoon wi gën a gaaw ngir dëgël komand walla laaj ci benn produwe.",
      "cta": "Ubbi WhatsApp"
    },
    "email": {
      "title": "E-mail",
      "description": "Yonnee nu bataaxal bu tar te dinañu la tontu ci 24h ouvré."
    },
    "address": {
      "title": "Adres",
      "description": "Compagnie Import Export & Distribution Africaine — Hann Mariste II, Dakar, Senegaal."
    },
    "hours": {
      "title": "Oras yi",
      "weekdays": "Altine – Àjjuma: 8h – 18h (GMT)",
      "weekend": "Gaawu: 9h – 14h (GMT) · Dibéer: tëju"
    }
  },
  "not_found": {
    "seo_title": "Xët bi amul",
    "seo_description": "Xët bi nga seet amul walla dañu ko yobbu.",
    "title": "Xët bi amul",
    "prefix": "Xët bi",
    "suffix": "amul walla dañu ko yobbu.",
    "back_home": "Dellu ci cëj bi",
    "view_catalog": "Xool katalog bi",
    "popular_heading": "Xët yi bare yi",
    "popular": {
      "home": "Cëj",
      "catalog": "Katalog produwe yi",
      "cart": "Sama paañe",
      "account": "Sama kont",
      "privacy": "Politig sagal bi",
      "terms": "Kondision yi"
    }
  }
}
